import { Col } from '@/app/components/Flex/Flex'
import { Lib } from '@/app/components/UI/Lib'
import { UI } from '@/app/components/UI/UI'
import { useChat } from '@/app/state/chat'
import { parseError } from '@/app/utils/error'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'

export const CleanPopup: FunctionalComponent<{
  onClose: () => void
}> = props => {
  const clean = useChat(s => s.clean)
  const [errors, setErrors] = useState<string[]>([])
  const [loading, setLoading] = useState(false)

  return (
    <UI.Popup
      onClose={props.onClose}
    >
      <Lib.PopupHeader>
        Очистить чат?
      </Lib.PopupHeader>

      <Lib.PopupMessage>
        Сообщения исчезнут навсегда
      </Lib.PopupMessage>

      <Lib.Errors errors={errors} />

      <Col grid gap={15}>
        <UI.Button
          size='m'
          type='secondary'
          onClick={props.onClose}
        >
          Нет
        </UI.Button>
        <UI.Button
          size='m'
          type='primary'
          disabled={loading}
          onClick={async () => {
            setLoading(true)
            try {
              setErrors([])
              await clean()
              props.onClose()
            }
            catch (e) {
              setErrors(parseError(e))
            }
            setLoading(false)
          }}
        >
          Очистить
        </UI.Button>
      </Col>
    </UI.Popup>
  )
}
